"use client";

import { getBranding } from "@/app/api/client-only";
import { I18nData } from "@/types/i18n";
import { Branding } from "@/types/branding";
import { useLocale } from "@/context/LocaleContext";
import LanguageSwitcher from "../language-switcher/language-switcher";
import "./header.scss";
import { useEffect, useState } from "react";

interface HeaderProps {
  slug: string;
  i18nData?: I18nData;
}

export default function Header({ slug, i18nData }: HeaderProps) {
  const { locale } = useLocale();
  const [branding, setBranding] = useState<Branding | null>(null);

  useEffect(() => {
    getBranding(slug).then(setBranding);
  }, [slug]);
  return (
    <header aria-label={i18nData?.[locale]?.header_aria_label ?? "Search Tool Header"} role="banner">
      <div id="headerBar">
        <h1 aria-label={i18nData?.[locale]?.heading_aria_label ?? "Heading"} style={{ display: "none" }}>
          {i18nData?.[locale]?.journal_search_tool ?? "Journal Search Tool"}
        </h1>
        <a
          id="logoLink"
          title={i18nData?.[locale]?.logo_tag ?? `Link to ${branding?.name} website`}
          aria-label={i18nData?.[locale]?.logo_aria_label ?? `${branding?.name} logo`}
          href={branding?.logo_link}
          target="_blank"
          rel="noopener noreferrer"
        >
          <div id="logo" />
        </a>
        <LanguageSwitcher i18nData={i18nData} />
      </div>
    </header>
  );
}
